import apiClient from "../../config/apiClient";

export const fetchDocuments = async (id) => {
  const user = window.localStorage.getItem("token");
  const token = user;
  return await apiClient.get(`/public/portal?url=patient/${id}/documents`, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

// 27503


